<template lang="pug">
    v-dialog(v-model="dialog" max-width="480" scrollable persistent :fullscreen="$vuetify.breakpoint.smAndDown")
        v-card(tile)
            v-card-title.title.caption--text {{title}}
            v-card-text
                v-select(chips multiple v-model="selectedColumns" clearable v-if="false"
                    :items="searchColumns"
                    :label="searchColumnsLabel")
                v-autocomplete(chips multiple v-model="selectedCompanies" clearable item-value="id" item-text="code"
                    :items="companies" :loading="loading" :filter="onFilterCompany" :search-input.sync="search"
                    :label="searchCompaniesLabel")
                    template(#item="data" v-if="true")
                        v-list-item-action(v-if="false")
                            v-checkbox(color="primary" v-model="data.item.selected")
                        v-list-item-content
                            v-list-item-title
                                highlighter(:text="data.item.code" :keyword="search")
                            v-list-item-subtitle
                                highlighter(:text="data.item.name" :keyword="search")
                v-select(chips multiple v-model="selectedServiceTypes" clearable :loading="serviceTypesFetching"
                :items="calendarServiceTypes"
                    :label="searchServiceTypesLabel")
                v-select(chips multiple v-model="selectedCalendarTypes" clearable
                :items="calendarCalendarTypes"
                    :label="searchCalendarTypesLabel")
                v-select(:chips="false" :multiple="false" v-model="selectedStatuses" clearable
                :items="userStatuses"
                    :label="searchStatusesLabel")
            v-layout(tag="v-card-actions")
                v-btn(@click="close" color="grey" depressed).px-3.white--text
                    v-icon(left dark) mdi-cancel
                    | {{$t('general.cancel')}}
                v-spacer
                v-btn(@click="onSearchAdvanceSubmit" color="primary" depressed).px-3
                    v-icon(left dark) mdi-check
                    | {{$t('general.ok')}}
</template>

<script>
import general from "../../mixins/general";
import _ from "lodash";

export default {
  name: "AdvancedSearchDialog",
  mixins: [general],
  props: {
    title: String,
    searchColumnsLabel: String,
    searchCompaniesLabel: String,
    searchServiceTypesLabel: {
      default: "Service Type"
    },
    searchCalendarTypesLabel: {
      default: "Calendar Type"
    },
    searchFavoriteLabel: {
      default: "Favorite"
    },
    searchStatusesLabel: String
  },
  data() {
    return {
      dialog: false,
      selectedColumns: [],
      selectedCompanies: [],
      selectedServiceTypes: [],
      selectedCalendarTypes: [],
      selectedStatuses: null,
      selectedFavorite: null,

      companies: [],
      loading: false,
      search: null
    };
  },
  computed: {
    showing: {
      get() {
        return this.dialog;
      }
    },
    searchColumns: {
      get() {
        return [
          {
            value: "users.name",
            text: this.$t("pages.settings.user.table.headers.name.title")
          },
          {
            value: "users.email",
            text: this.$t("pages.settings.user.table.headers.email.title")
          },
          {
            value: "users.phone_no",
            text: this.$t("pages.settings.user.table.headers.phone_no.title")
          }
        ];
      }
    }
  },
  methods: {
    show() {
      this.fetchServiceTypes(undefined);
      this.dialog = true;
      this.loading = true;
      this.axios
        .get(`companies?allThin`)
        .then(res => {
          const companies = res.data.filter(c => c.status);
          this.companies = _.map(companies, c => ({
            ...c,
            selected: this.selectedCompanies.includes(c.id)
          }));
        })
        .finally(() => (this.loading = false));
    },
    close() {
      this.dialog = false;
    },
    onSearchAdvanceSubmit() {
      this.close();
      this.$emit("submit", {
        columns: this.selectedColumns,
        companies: this.selectedCompanies,
        status:
          typeof this.selectedStatuses === "boolean"
            ? [this.selectedStatuses]
            : [],
        serviceTypes: this.selectedServiceTypes,
        calendarTypes: this.selectedCalendarTypes,
        favorite:
          typeof this.selectedFavorite === "boolean"
            ? [this.selectedFavorite]
            : []
      });
    },
    onFilterCompany(item) {
      return item.code.includes(this.search) || item.name.includes(this.search);
    }
  }
};
</script>
